import api from "../api";
import apiNoAuth from "../apiNoAuth";

export class LocalitiesService {

    static fetchLocalityLevel(){return apiNoAuth.get('/localities/locality-levels').catch(e=>console.log(e))}

    static fetchLocalityByProject(project_id){return api.get(`/localities/list/${project_id}`).catch(e=>console.log(e))}
}
